import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RktIconService {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer
  ) {}

  public registerIcons(): void {
    this.addMatIcon('add_participant');
    this.addMatIcon('document');
    this.addMatIcon('error');
    this.addMatIcon('help-default');
    this.addMatIcon('information');
    this.addMatIcon('microphone');
    this.addMatIcon('participant-nonsa');
    this.addMatIcon('participant-sa');
    this.addMatIcon('participant-witness');
    this.addMatIcon('photo_camera');
    this.addMatIcon('play_music');
    this.addMatIcon('plus');
    this.addMatIcon('pre-sign');
    this.addMatIcon('success');
    this.addMatIcon('visibility-default');
    this.addMatIcon('visibility_off-default');
  }

  private addMatIcon(iconName: string) {
    this.matIconRegistry.addSvgIcon(
      iconName,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../../assets/material-icons/${iconName}.svg`
      )
    );
  }
}
